import {
  GET_STUDENT_SESSIONS,
  GET_STUDENT_SESSIONS_SUCCESS,
  GET_STUDENT_SESSIONS_FAILED,

  GET_TEACHER_DETAILS,
  GET_TEACHER_DETAILS_FAILED,
  GET_TEACHER_DETAILS_SUCCESS,
  SET_DASHBOARD_FILTERS,
  GET_STUDENT_PRACTICE_SESSIONS,
  GET_STUDENT_CHALLENGE_SESSIONS,
  GET_STUDENT_CHAPTER_PROGRESS,
  GET_RECENT_ASSIGNMENT_SUCCESS,
  GET_RECENT_ASSIGNMENT_FAILED,
  GET_CLASS_ASSIGNMENT_SESSION,
  GET_CLASS_ASSIGNMENT_SESSION_SUCCESS,
  GET_CLASS_ASSIGNMENT_SESSION_FAILED,
  GET_LEADERBOARD,
  GET_LEADERBOARD_SUCCESS,
  GET_LEADERBOARD_FAILED,
  GET_CLASS_PROGRESS,
  GET_CLASS_PROGRESS_SUCCESS,
  GET_CLASS_PROGRESS_FAILED
} from "../../constants/ActionTypes";
const filters  = localStorage.getItem("dashboard_filters")?JSON.parse(localStorage.getItem("dashboard_filters")):{
  "board": "CBSE",
  "level": 10,
  "subject": "maths"
}
const INIT_STATE = {
  teacher_details: null,
  student_sessions: [],
  dashboard_filters: filters,
  class_session_id: null,
  class_session: null
};


export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_TEACHER_DETAILS: {
      return {
        ...state,
        loading: true
      }
    }
    case GET_TEACHER_DETAILS_SUCCESS: {
      return {
        ...state,
        teacher_details: action.payload,
        loading: false
      }
    }
    case GET_TEACHER_DETAILS_FAILED: {
      return {
        ...state,
        teacher_details: {},
        loading: false,
        alertMessage: action.payload,
        showMessage: true,
      }
    }
    case GET_STUDENT_SESSIONS: {
      return {
        ...state,
        loading: true,
        student_sessions: action.payload,
      }
    }
    case GET_STUDENT_SESSIONS_SUCCESS: {
      return {
        ...state,
        student_sessions: action.payload,
        loading: false
      }
    }
    case GET_STUDENT_SESSIONS_FAILED: {
      return {
        ...state,
        student_sessions: [],
        loading: false,
        alertMessage: action.payload,
        showMessage: true,
      }
    }
    case GET_RECENT_ASSIGNMENT_SUCCESS: {
      return {
        ...state,
        recent_assignments: action.payload,
        loading: false
      }
    }
    case GET_RECENT_ASSIGNMENT_FAILED: {
      return {
        ...state,
        recent_assignments: [],
        loading: false,
        alertMessage: action.payload,
        showMessage: true,
      }
    }

    case SET_DASHBOARD_FILTERS: {
      localStorage.setItem("dashboard_filters",JSON.stringify(action.payload))
      return {
        ...state,
        dashboard_filters: { ...action.payload },
        loading: true
      }
    }
    case GET_STUDENT_PRACTICE_SESSIONS: {
      return {
        ...state,
        practice_sessions: action.payload,
        loading: true
      }
    }
    case GET_STUDENT_CHAPTER_PROGRESS: {
      return {
        ...state,
        chapter_progress: action.payload,
        loading: true
      }
    }

    case GET_STUDENT_CHALLENGE_SESSIONS: {
      return {
        ...state,
        challenge_sessions: action.payload,
        loading: true
      }
    }
    case GET_CLASS_ASSIGNMENT_SESSION: {
      return {
        ...state,
        loading: true,
        class_session_id: action.payload
      }
    }
    case GET_CLASS_ASSIGNMENT_SESSION_SUCCESS: {
      return {
        ...state,
        loading: false,
        class_session: action.payload
      }
    }
    case GET_CLASS_ASSIGNMENT_SESSION_FAILED: {
      return {
        ...state,
        loading: false,
        class_session: null,
        alertMessage: action.payload,
        showMessage: true,
      }
    }
    case GET_LEADERBOARD: {
      return {
        ...state,
        loading: true,
        loading_leaderboard:true
        // class_session_id: action.payload
      }
    }
    case GET_LEADERBOARD_SUCCESS: {
      return {
        ...state,
        loading: false,
        loading_leaderboard:false,
        leaderboard: action.payload
      }
    }
    case GET_LEADERBOARD_FAILED: {
      return {
        ...state,
        loading: false,
        loading_leaderboard:false,
        leaderboard: null,
        alertMessage: action.payload,
        showMessage: true,
      }
    }

    case GET_CLASS_PROGRESS: {
      return {
        ...state,
        loading: true,
        loading_class_progress:true
        // class_session_id: action.payload
      }
    }
    case GET_CLASS_PROGRESS_SUCCESS: {
      return {
        ...state,
        loading: false,
        loading_class_progress:false,
        class_progress: action.payload
      }
    }
    case GET_CLASS_PROGRESS_FAILED: {
      return {
        ...state,
        loading: false,
        loading_class_progress:false,
        class_progress: null,
        alertMessage: action.payload,
        showMessage: true,
      }
    }
    default:
      return state;
  }
}
